import fontawesome from '@fortawesome/fontawesome';
// Brands
import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF';
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';
import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin';
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
import faWhatsapp from '@fortawesome/fontawesome-free-brands/faWhatsapp';
import faYoutube from '@fortawesome/fontawesome-free-brands/faYoutube';
// import { faFacebookF, faLinkedin, faTwitter, faYoutube } from '@fortawesome/fontawesome-free-brands';

// Light.
import faCalendar from '@fortawesome/fontawesome-pro-light/faCalendar';
import faCaretRight from '@fortawesome/fontawesome-pro-light/faCaretRight';
import faCircle from '@fortawesome/fontawesome-pro-light/faCircle';
import faInfo from '@fortawesome/fontawesome-pro-light/faInfo';
import faNewspaper from '@fortawesome/fontawesome-pro-light/faNewspaper';
import faQuestion from '@fortawesome/fontawesome-pro-light/faQuestion';
import faThumbsUp from '@fortawesome/fontawesome-pro-light/faThumbsUp';
// import {
// 	faCalendar,
// 	faCircle,
// 	faInfo,
// 	faNewspaper,
// 	faQuestion,
// 	faThumbsUp,
// } from '@fortawesome/fontawesome-pro-light';

// Regular.
import faCalendarAlt from '@fortawesome/fontawesome-pro-regular/faCalendarAlt';
import faCheckCircle from '@fortawesome/fontawesome-pro-regular/faCheckCircle';
import faClock from '@fortawesome/fontawesome-pro-regular/faClock';
import faEnvelope from '@fortawesome/fontawesome-pro-regular/faEnvelope';
import faFolderOpen from '@fortawesome/fontawesome-pro-regular/faFolderOpen';
import faMapMarkerAlt from '@fortawesome/fontawesome-pro-regular/faMapMarkerAlt';
import faMobile from '@fortawesome/fontawesome-pro-regular/faMobile';
import faPlusCircle from '@fortawesome/fontawesome-pro-regular/faPlusCircle';
import faPhone from '@fortawesome/fontawesome-pro-regular/faPhone';
import faQuestionCircle from '@fortawesome/fontawesome-pro-regular/faQuestionCircle';
import faSearch from '@fortawesome/fontawesome-pro-regular/faSearch';
import faShoppingCart from '@fortawesome/fontawesome-pro-regular/faShoppingCart';
import faSignInAlt from '@fortawesome/fontawesome-pro-regular/faSignInAlt';
import faSmile from '@fortawesome/fontawesome-pro-regular/faSmile';
import faStar from '@fortawesome/fontawesome-pro-regular/faStar';
import faTags from '@fortawesome/fontawesome-pro-regular/faTags';
import faTrophy from '@fortawesome/fontawesome-pro-regular/faTrophy';
import faUser from '@fortawesome/fontawesome-pro-regular/faUser';
import faUsers from '@fortawesome/fontawesome-pro-regular/faUsers';
import faBars from '@fortawesome/fontawesome-pro-regular/faBars';
import faUserMd from '@fortawesome/fontawesome-pro-regular/faUserMd';
// import {
// 	faCalendarAlt,
// 	faCheckCircle,
// 	faClock,
// 	faEnvelope,
// 	faFolderOpen,
// 	faMapMarkerAlt,
// 	faPlusCircle,
// 	faPhone,
// 	faQuestionCircle,
// 	faShoppingCart,
// 	faSignInAlt,
// 	faStar,
// 	faTags,
// 	faUser,
// } from '@fortawesome/fontawesome-pro-regular';

// Solid.
import faAngleRight from '@fortawesome/fontawesome-pro-solid/faAngleRight';
import faAngleUp from '@fortawesome/fontawesome-pro-solid/faAngleUp';
import faAngleDown from '@fortawesome/fontawesome-pro-solid/faAngleDown';
import faArrowAltRight from '@fortawesome/fontawesome-pro-solid/faArrowAltRight';
import faArrowDown from '@fortawesome/fontawesome-pro-solid/faArrowDown';
import faArrowUp from '@fortawesome/fontawesome-pro-solid/faArrowUp';
import faCaretRightSolid from '@fortawesome/fontawesome-pro-solid/faCaretRight';
import faCaretLeftSolid from '@fortawesome/fontawesome-pro-solid/faCaretLeft';
import faCheck from '@fortawesome/fontawesome-pro-solid/faCheck';
import faCheckCircleSolid from '@fortawesome/fontawesome-pro-solid/faCheckCircle';
import faChevronLeft from '@fortawesome/fontawesome-pro-solid/faChevronLeft';
import faChevronRight from '@fortawesome/fontawesome-pro-solid/faChevronRight';
import faChevronDown from '@fortawesome/fontawesome-pro-solid/faChevronDown';
import faCircleSolid from '@fortawesome/fontawesome-pro-solid/faCircle';
import faQuestionCircleSolid from '@fortawesome/fontawesome-pro-solid/faQuestionCircle';
import faQuoteLeft from '@fortawesome/fontawesome-pro-solid/faQuoteLeft';
import faQuoteRight from '@fortawesome/fontawesome-pro-solid/faQuoteRight';
import faSignInAltSolid from '@fortawesome/fontawesome-pro-solid/faSignInAlt';
import faStarSolid from '@fortawesome/fontawesome-pro-solid/faStar';
import faStarHalf from '@fortawesome/fontawesome-pro-solid/faStarHalf';

// import {
// 	faAngleRight,
// 	faAngleDown,
// 	faArrowAltRight,
// 	faArrowDown,
// 	faArrowUp,
// 	faCheck,
// 	faCheckCircle as faCheckCircleSolid,
// 	faChevronLeft,
// 	faChevronRight,
// 	faCircle as faCircleSolid,
// 	faQuestionCircle as faQuestionCircleSolid,
// 	faSignInAlt as faSignInAltSolid,
// 	faStar as faStarSolid,
// 	faStarHalf,
// } from '@fortawesome/fontawesome-pro-solid';

fontawesome.library.add(
	faFacebookF,
	faInstagram,
	faLinkedin,
	faTwitter,
	faWhatsapp,
	faYoutube,
	faCalendar,
	faCaretRight,
	faCircle,
	faInfo,
	faNewspaper,
	faQuestion,
	faThumbsUp,
	faCalendarAlt,
	faCheckCircle,
	faClock,
	faEnvelope,
	faFolderOpen,
	faMapMarkerAlt,
	faMobile,
	faPlusCircle,
	faPhone,
	faQuestionCircle,
	faSearch,
	faShoppingCart,
	faSignInAlt,
	faSmile,
	faStar,
	faTags,
	faTrophy,
	faUser,
	faUsers,
	faAngleRight,
	faAngleUp,
	faAngleDown,
	faArrowAltRight,
	faArrowDown,
	faArrowUp,
	faCheck,
	faCheckCircleSolid,
	faChevronLeft,
	faChevronRight,
	faChevronDown,
	faCaretRightSolid,
	faCaretLeftSolid,
	faCircleSolid,
	faQuestionCircleSolid,
	faQuoteLeft,
	faQuoteRight,
	faSignInAltSolid,
	faStarSolid,
	faStarHalf,
	faBars,
	faUserMd
);
